<div class="container">
    <h1>
        Finn din kommune
    </h1>
    <p class="description">
        Finn fram til riktig tjeneste, kontor eller organisasjon som kan gi råd og informasjon.
    </p>

    @if (loaded()) {
        <hb-felt-autocomplete [control]="control" [data]="data" [optionTemplate]="kommunemal">Fyll inn din kommune
        </hb-felt-autocomplete>

        <ng-template #kommunemal let-option>
            <span class="hb-text--secondary">{{ option.fylkesnavn }}</span><br>
            <small class="hb-text--sm">{{ option.tekst }}</small>
        </ng-template>
    }

    @if (hjemmeside()) {
        <p>{{ kommunenavn() }} kommunes nettside:</p>
        <a [href]="hjemmeside()" target="_blank">{{ hjemmeside() }}</a>
    }

</div>
